module.exports = __webpack_public_path__ + "static/media/gravure3.9d97e7ce.jpg";